import React from "react";
import classes from "./TopHeader.scss";
import { LeftIcon, ToddleIcon } from "SvgComponents";
import { colors } from "Constants";
import { DownloadCloudOutlined } from "@toddle-edu/ds-icons";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import { Button, IconButton } from "@toddle-edu/ds-web";

const TopHeader = React.memo(
  ({
    title,
    subTitle,
    onGoBackClick,
    showToddleIcon,
    containerStyle,
    showDownloadIcon,
    handleDownloadClick,
    t,
  }) => {
    return (
      <div className={classes.container} style={containerStyle}>
        <div className={classes.leftContainer}>
          <Button
            className={classes.backButtonContainer}
            onClick={onGoBackClick}
            dsVersion="2.0"
            variant={"neutral"}
            type={"plain"}
            size={"medium"}
            aria-label={t("common:go_back")}
          >
            <div className={classes.backIconContainer}>
              <LeftIcon fill={colors.neutral400} />
            </div>
            {showToddleIcon && (
              <div className={classes.toddleIconContainer}>
                <ToddleIcon />
              </div>
            )}
          </Button>
          <div className={classes.infoContainer}>
            <div className={classes.title}>{title}</div>
            {subTitle && <div className={classes.subTitle}>{subTitle}</div>}
          </div>
        </div>
        {showDownloadIcon ? (
          <div className={classes.downloadIcon}>
            <LinkWithTooltip
              tooltip={t("common:download")}
              placement={"bottom"}
            >
              <IconButton
                icon={<DownloadCloudOutlined size="x-small" variant="subtle" />}
                onClick={handleDownloadClick}
                dsVersion="2.0"
                variant={"neutral"}
                type={"plain"}
                size={"medium"}
                aria-label={t("common:download")}
              />
            </LinkWithTooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
);

TopHeader.displayName = "TopHeader";

export default TopHeader;
